gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.text-animation-section').forEach((section) => {
        // Split both content elements
        const content1 = section.querySelector('.content');

        const split1 = new SplitType(content1, { type: 'words' });
        // console.log('this');

        // Create a timeline with sequenced animations
        const tWords = gsap.timeline().from(split1.words, {
            opacity: 0.15,
            ease: 'none',
            stagger: 1,
            duration: 2,
        }); // Starts after previous animation

        // Single ScrollTrigger for the entire section
        ScrollTrigger.create({
            animation: tWords,
            trigger: section,
            start: 'top+=50% bottom',
            end: 'top-=10% top', // Double the scroll distance
            scrub: true,
            pin: false,
        });
    });
});
